// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__fCMjT","modal":"modal_modal__Nszx8","content":"modal_content__nrtR0","open":"modal_open__YFZrL","container":"modal_container__zLYYF"};